export class KlaviyoPopup {
  constructor(el) {
    if (el) {
      this.init(el);
    }
  }

  init(el) {
    this.el = el;
    this.render();
  }




  render() {
    this.loadPopup();
  }
  
  loadPopup() {
    let cookieMonth = this.getCookie('monthDelay');
    let cookieDay = this.getCookie('twoDayDelay');
    let $this = this;

    window.addEventListener("klaviyoForms", function(e) { 
      if(e.detail.formId === 'VnVGp3') {
        e.detail.type === 'submit' ? $this.setCookie("monthDelay", 1, 30) : '';
        if(e.detail.type === 'open') {
          setTimeout(() => {
            let buttonEl = document.querySelectorAll('button.needsclick');
            for(let button of buttonEl) {
              console.log('5 day delay');
              button.addEventListener('click', () => {
                $this.setCookie('twoDayDelay', 1, 5);
              })
            }
          },500)
        }
      }
    });

    if(cookieMonth !== '1' && cookieDay !== '1') {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'VnVGp3']);
      console.log(window._klOnsite._loaded);
    }
  }

  setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + (days*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  }

  getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

}
